// The zoom a PDF opens at.
//
// The real fix sits in the DOCUMENT (server: services/pdfDocument.ts writes /OpenAction), so a
// downloaded or mailed file opens at page width too. This here is the NET, and it exists for
// one concrete case: a PDF produced BEFORE that change carries no OpenAction — every invoice
// and certificate already lying in the storage folder. For those the fragment is all there is.
//
// `#view=FitH` is the PDF Open Parameters spelling and the one the standard names; Chromium
// also understands `#zoom=page-width`, WebKit understands little of either. That asymmetry is
// exactly why the document itself carries the instruction.
export function pdfFitWidth(url: string): string {
    if (!url) return url
    // Never touch an address that already carries a fragment — it may mean something.
    if (url.includes('#')) return url
    return `${url}#view=FitH`
}
